export const initializeAuth = async (store) => {
    await store.dispatch('Auth/initialize');
};
